<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    v-if="profile != null"
>
    <div
        style="display: flex"
    >
        <div
            style="flex-grow: 1"
        >
            <v-text-field
                label="Bulk Message Name"
                :value="profile.label"
                readonly
                disabled
            />
        </div>
        <div
            style="flex-grow: 0; margin-top: 15px; margin-left: 15px;"
        >
            <v-btn
                v-on:click="onClickBack"
            >
                Back
            </v-btn>
        </div>
    </div>

    <b>Message Patterns</b>
    <ul class="text-body-1">
        <li
            v-for="(pattern, index) in profile.message_patterns"
            :key="index"
        >
            {{ pattern }}
        </li>
    </ul>

    <m-model-r1-layer-editor
        v-for="(layer, index) in layers"
        :key="index"
        :layer="layer"
        style="margin-bottom: 15px"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            profile: null,

            layers: [
                'days-since-last-non-club-purchase',
                'days-since-last-promotional-message',
                'bulk-message-order-attribution-percentile',
                'is-active-club-member',
                'background'
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        doUpdate() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/bulk/messages/get-profile/:bulk_message_id',
            
                'params' : {
                        'bulk_message_id': this.$route.params.bulk_message_id
                    },
            
                'on_success': (data) => {
                        this.profile = data;
                    },
            
                'on_error': 'Unable to get bulk message profile',
            });
        },

        onClickBack()
        {
            this.$router.push({
                'name': 'bulk-message-sentiment-forecast',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                }
            });
        },
    },

    computed: {
        title() {
            if ( this.profile == null )
                return 'Sentiment Forecast Model';

            return 'Sentiment Forecast Model: '+this.profile.label;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>